import React, { useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useForm,Controller } from "react-hook-form";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { SaveLoader } from "@/_components";
import { accountService } from "@/_services";
import { history } from "@/_helpers";
import Cookies from "universal-cookie";

import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import { green } from "@mui/material/colors";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
// import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { LifeSafer } from "@/_helpers/BrandConstants";

const GreenRadio = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const RedTextTypography = withStyles({
  root: {
    fontSize: 12,
    color: "#d1495b",
    fontWeight: 600,
    fontStyle: "italic",
    textAlign: "center",
  },
})(Typography);

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: { margin: theme.spacing(3, 0, 2) },
  buttonIco: { width: 24, height: 24, marginRight: 10, marginTop: 7 },
  inputIco: { opacity: 0.6, color: "#1c355e" },
}));

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function ForgotPassword() {
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const classes = useStyles();
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const [hasSubmit, setHasSubmit] = useState(false);
  const [emailText, setEmailText] = useState();
  const [showResetOptions, setShowResetOptions] = useState(false);
  const [showResetCode, setShowResetCode] = useState(false);
  const [resetOption, setResetOption] = useState("");
  const [invalidCodeCtr, setInvalidCodeCtr] = useState(1);
   const [isPhone, setIsPhone] = useState(false);
  const [inputValue, setInputValue] = useState("");
  // get email from query parameters and populate it as default value
  const email = useQuery().get("email");
  const { register, errors, handleSubmit, control, trigger } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      email,
    },
  });

  const handleInputChange = (event) => {
    let { value } = event.target;
    const hasAt = value.includes("@");
    const hasLetter = /[a-zA-Z]/.test(value || "");
    let isPhoneValue = false;
    if (hasAt || hasLetter) {
      setIsPhone(false);
      isPhoneValue = false;
    } else {
      setIsPhone(true);
      isPhoneValue = true;
    }
    if (countryCode === "USA" && isPhoneValue) {
      const numericValue = value.replace(/[^\d]/g, "");

      if (numericValue.length > 3 && numericValue.length <= 6) {
        value = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
      } else if (numericValue.length > 6) {
        value = `(${numericValue.slice(0, 3)}) ${numericValue.slice(
          3,
          6
        )}-${numericValue.slice(6, 10)}`;
      }
    } else {
      value = value.replace(/[^a-zA-Z\d@.+]/g, "");
    }
    setInputValue(value);
  };


  const onSubmit = (data) => {
    setSubmitting(true);
  
     let phoneData ={
        isPhone: true,
        phoneNumber: data?.email?data?.email?.replace(/\D/g, ""):emailText?.replace(/\D/g, ""),
        emailAddress: null,
        brandIdentifier: brand,
      }

      let emailData = {
        emailAddress: data?.email?data?.email:emailText,
        phoneNumber: null,
        isPhone: false,
        brandIdentifier: brand,
      };

    if (showResetOptions === false && showResetCode === false) {
      //Call ForgotPassword waiting for 'Sent' or 'Both' response
      // 'Both' prompts dispaly of Reset Options section
      // accountService
      //   .forgotPassword(phoneData)
        accountService.forgotPassword(isPhone?phoneData:emailData)
        .then((rtn) => {
          if (rtn.message === "Sent") {
            toast.success(t("account.resetPasswordSuccess"));
            setHasSubmit(true);
          } else if (rtn.message === "Both") {
            setEmailText(data?.email);
            setShowResetOptions(true);
          }
        })
        .catch((error) => {
          if (error) {
            isPhone?
            toast.error(t("account.resetPhoneError")):
            toast.error(t("account.resetPasswordError"));
          } else {
            console.log(error);
          }
        }).finally(() => {
         setSubmitting(false);
        });
    } else if (
      showResetOptions === true &&
      showResetCode === false &&
      resetOption === "Email"
    ) {
      //Reset Option Email selected call ResetEmail
      accountService
        .sendResetEmail(isPhone?phoneData:emailData)
        .then((rtn) => {
          if (rtn.message === "Sent") {
            toast.success(t("account.resetPasswordSuccess"));
            setResetOption("");
            setShowResetOptions(false);
            setHasSubmit(true);
          }
        })
        .catch((error) => {
          // setSubmitting(false);
          if (error) {
            isPhone?
            toast.error(t("account.resetPhoneError")):
            toast.error(t("account.resetPasswordError"));
          } else {
            console.log(error);
          }
        }).finally(() => {
         setSubmitting(false);
        });
    } else if (
      showResetOptions === true &&
      showResetCode === false &&
      resetOption === "Text"
    ) {
      //Send ResetCode and Show Reset Code section
      accountService
        .resetCode(isPhone?phoneData:emailData)
        .then(() => {
          toast.success(t("account.resetCodeSent"));
          setShowResetOptions(false);
          setShowResetCode(true);
        })
        .catch((error) => {
          if (error) {
            toast.error(t("account.resetCodeError"));
          } else {
            console.log(error);
          }
        }).finally(() => {
         setSubmitting(false);
        });
    } else if (showResetCode === true) {
      //Reset Code entered submit it and then check for Invalid/Expired response
      //Only allow 3 attempts when 'Invalid' has been returned
      if (invalidCodeCtr < 3) {
        let code = parseInt(data.resetCode);
         let resetCodeDataEmail = {
            emailAddress: data?.email?data?.email:emailText,
            isPhone: false,
            resetCode: code,
            phoneNumber: null,
            brandIdentifier: brand,
          }
          let resetCodeDataPhone = {
            phoneNumber: data?.email?data?.email?.replace(/\D/g, ""):emailText?.replace(/\D/g, ""),
            isPhone: true,
            resetCode: code,
            emailAddress: null,
            brandIdentifier: brand,
        }
        accountService
          .resetCodeVerify(isPhone?resetCodeDataPhone:resetCodeDataEmail)
          .then((rtn) => {
            if (rtn.message === "Invalid") {
              setInvalidCodeCtr(invalidCodeCtr + 1);
              toast.error(t("account.resetCodeInvalid"));
            } else if (rtn.message === "Expired") {
              toast.error(t("account.resetCodeExpired"));
              //Return to Reset Options
              setInvalidCodeCtr(0);
              setShowResetCode(false);
              setShowResetOptions(true);
            } else {
              history.push({
                pathname: "/account/reset-password",
                search: "?token=" + rtn.token + "&userId=" + rtn.userId,
              });
            }
          })
          .catch((error) => {
            // setSubmitting(false);
            if (error) {
              toast.error(t("account.resetCodeError"));
            } else {
              console.log(error);
            }
          }).finally(() => {
          setSubmitting(false);
        });
      } else {
        setInvalidCodeCtr(0);
        setShowResetCode(false);
        setShowResetOptions(true);
      }
    }

    // setSubmitting(false);
  };

  const handleRadioChange = (event) => {
    let selectedOption = event.target.value;

    setResetOption(selectedOption);
    //TODO FINISH THIS
  };

  return (
    <>
      {hasSubmit === true ? (
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          direction="column"
        >
          <Grid item>
            <RedTextTypography>
              {t("account.resetPasswordSent")}
            </RedTextTypography>
          </Grid>
        </Grid>
      ) : (
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
          {showResetCode === true ? (
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              direction="column"
              style={{ paddingTop: 20, paddingBottom: 50 }}
            >
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="resetCode"
                label={t("account.resetCode")}
                name="resetCode"
                autoComplete="resetCode"
                error={!!errors.resetCode}
                helperText={errors.resetCode ? errors.resetCode.message : ""}
                autoFocus
                inputRef={register({
                  required: {
                    value: true,
                    message: t("account.resetCodeRequired"),
                  },
                  pattern: {
                    value: /^[0-9]*$/,
                    message: t("account.resetCodeInputInvalid"),
                  },
                })}
              />
            </Grid>
          ) : showResetOptions === true ? (
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              direction="column"
              style={{ paddingTop: 20, paddingBottom: 50 }}
            >
              <Grid container item direction="column" xs={6}>
                {countryCode === "USA" && (
                  <>
                    <Grid
                      container
                      item
                      alignItems="center"
                      direction="row"
                      style={{ paddingLeft: 50 }}
                    >
                      <Grid item>
                        <GreenRadio
                          id="resetOptionText"
                          name="resetOptionText"
                          checked={resetOption === "Text"}
                          onChange={handleRadioChange}
                          value={"Text"}
                        />
                      </Grid>
                      <Grid item>
                        <Typography>{t("account.receiveText")}</Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      item
                      justifyContent="center"
                      direction="row"
                      style={{ paddingLeft: 50, paddingBottom: 20 }}
                    >
                      <Grid item>
                        <RedTextTypography>
                          {t("account.providerChgMessage")}
                        </RedTextTypography>
                      </Grid>
                    </Grid>
                  </>
                )}

                <Grid
                  container
                  item
                  alignItems="center"
                  direction="row"
                  style={{ paddingLeft: 50 }}
                >
                  <Grid item>
                    <GreenRadio
                      id="resetOptionEmail"
                      name="resetOptionEmail"
                      checked={resetOption === "Email"}
                      onChange={handleRadioChange}
                      value={"Email"}
                    />
                  </Grid>
                  <Grid item>
                    <Typography>{t("account.receiveEmail")}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ) : (
            // <TextField
            //   variant="outlined"
            //   margin="normal"
            //   fullWidth
            //   id="email"
            //   label={t("account.email")}
            //   name="email"
            //   autoComplete="email"
            //   error={!!errors.email}
            //   helperText={errors.email ? errors.email.message : ""}
            //   autoFocus
            //   inputRef={register({
            //     required: { value: true, message: t("account.emailRequired") },
            //     pattern: {
            //       value: /^\S+@\S+$/i,
            //       message: t("account.emailValid"),
            //     },
            //   })}
            //   InputProps={{
            //     startAdornment: (
            //       <InputAdornment position="start">
            //         <EmailOutlinedIcon className={classes.inputIco} />
            //       </InputAdornment>
            //     ),
            //   }}
            // />

            <Controller
              name="email"
              control={control}
              defaultValue={inputValue}
              rules={{
                required: {
                  value: true,
                  message: countryCode === "USA"? t("account.phoneEmailRequired"): t("account.emailRequired"),
                },
                validate: (value) => {
                  if (countryCode === "USA" && !value) {
                    return t("account.phoneEmailRequired");
                  }
                  const cleanValue = value.trim();
                  const hasAt = cleanValue.includes("@");
                  const hasLetter = /[a-zA-Z]/.test(cleanValue || "");
                  if (countryCode === "AU" || hasAt || hasLetter) {
                    const isValidEmail = /^\S+@\S+\.\S+$/.test(cleanValue);
                    return isValidEmail ? true : t("account.emailValid");
                  } else {
                    if (
                      value.replace(/\D/g, "").length === 10 ||
                      value.replace(/\D/g, "").length === 11 ||
                      value.length === 0
                    ) {
                      return true;
                    } else {
                      return t("account.phoneValid");
                    }
                  }
                },
              }}
              render={(field) => (
                <TextField
                  {...field}
                  data-cy="email"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="email"
                  label={
                    countryCode === "USA"
                      ? t("account.phoneEmail")
                      : t("account.email")
                  }
                  name="email"
                  autoComplete="email"
                  error={!!errors.email}
                  helperText={errors.email ? errors.email.message : ""}
                  onChange={(e) => {
                    handleInputChange(e);
                    field?.onChange(e);
                    trigger("email");
                  }}
                  value={inputValue}
                  maxLength={10}
                  autoFocus
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonOutlineOutlinedIcon
                          className={classes.inputIco}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          )}
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            direction="column"
          >
            <Grid item>
              {submitting === false ? (
                <Button
                  type="submit"
                  size="medium"
                  disabled={submitting}
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  style={{ width: 240, height: 50 }}
                >
                  {t("account.resetPasswordButton")}
                </Button>
              ) : (
                <SaveLoader />
              )}
            </Grid>
            <Grid item>
              <img src={"./src/_images/orLine.png"} alt="OR" />
            </Grid>
            <Grid item style={{ paddingBottom: 15 }}>
              <RouterLink to="login" style={{ textDecoration: "none" }}>
                <Button
                  type="submit"
                  size="medium"
                  disabled={submitting}
                  variant="contained"
                  color="secondary"
                  style={{ width: 240, height: 50 }}
                >
                  {t("account.backToSignInButton")}
                </Button>
              </RouterLink>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
}

ForgotPassword.propTypes = {
  history: PropTypes.object.isRequired,
};

export default ForgotPassword;
